import Button from "./Button"
import StoresListItems from "./StoresListItem"
import { useFetchStoresQuery, useAddStoreMutation } from "../store"
import { faker } from "@faker-js/faker"

const StoresList = ({ owner }) => {
  const { data, isLoading, error } = useFetchStoresQuery(owner)
  const [addStore, resultAddStore] = useAddStoreMutation()

  const handleAddStore = () => {
    addStore({ name: faker.company.name(), owner: owner.id })
  }

  let content, heading
  if (isLoading) {
    heading = <p>Loading...</p>
  } else if (error) {
    content = <p>Something went wrong</p>
  } else {
    content = data.map((store) => (
      <StoresListItems key={store.id} store={store} />
    ))
    heading = `${data?.length} ${
      data?.length === 1 ? "Store" : "Stores"
    } were found
    for ${owner.firstName || owner.email}`
  }

  return (
    <div className="m-6">
      <div className="flex flex-row justify-between items-center">
        <h3 className="text-gray-300 text-sm">{heading}</h3>
        <Button onClick={handleAddStore} loading={resultAddStore.isLoading}>
          + Add Store
        </Button>
      </div>
      {content}
    </div>
  )
}

export default StoresList
